import Reflux from 'reflux'

var actions = Reflux.createActions([
  'isGuest',
  'logout',
  'login',
  'setCustomerUploadData',
  'setSupplierUploadData',
  'setSupplierRules',
  'setBankUploadData',
  'setCustomerAssignmentData',
  'setUnprocessedFlag',
  'setProcessedItems',
  'setUnProcessedItems',
  'setCashregisterOutputFiles',
  'uploadDataSet',
  'userBalanceSet',
  'updateStartEndDate',
])

export default actions


// WEBPACK FOOTER //
// ./src/actions/actions.js